import React from 'react';

import 'scss/shared/loader.scss';

export default function LoadingIndicator(props) {
    return (
        <div className="loader">Loading...</div>
    );
}
